import { Scorecard } from 'actions/actionTypes';

export const changeScorecard = (name, value) => ({ type: Scorecard.CHANGE_SCORECARD, payload: { name, value } });

export const loadScorecardInfoRequest = (gameRoundId, scorecardType) => ({ type: Scorecard.LOAD_SCORECARD_INFO_REQUEST, payload: { gameRoundId, scorecardType } });
export const loadScorecardInfoSuccess = (responseData) => ({ type: Scorecard.LOAD_SCORECARD_INFO_SUCCESS, payload: responseData });
export const loadScorecardInfoFailure = (errorMessage) => ({ type: Scorecard.LOAD_SCORECARD_INFO_FAILURE, payload: errorMessage })